import React from "react";

interface CheckoutSummaryProps {
  cartTotal: number;
  otherCharges: number;
  discount: number;
  grandTotal: number;
  exchangeDiscount?: number;
}

export const CheckoutSummary: React.FC<CheckoutSummaryProps> = ({
  cartTotal,
  otherCharges,
  discount,
  grandTotal,
  exchangeDiscount = 0,
}) => {
  return (
    <div className="border border-gray-100 rounded-lg overflow-hidden shadow-sm">
      <div className="flex justify-between items-center px-3 py-2 border-b border-gray-50 bg-white">
        <span className="text-[11px] text-gray-500">Cart Subtotal</span>
        <span className="text-[11px] text-gray-500">
          LKR{" "}
          {cartTotal.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}
        </span>
      </div>
      {otherCharges > 0 && (
        <div className="flex justify-between items-center px-3 py-2 border-b border-gray-50 bg-white">
          <span className="text-[11px] text-gray-500">Other Charges (+)</span>
          <span className="text-[11px] text-gray-500">
            LKR{" "}
            {otherCharges.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </span>
        </div>
      )}
      {discount > 0 && (
        <div className="flex justify-between items-center px-3 py-2 border-b border-gray-50 bg-white">
          <span className="text-[11px] text-gray-500">Discount (-)</span>
          <span className="text-[11px] text-red-500">
            LKR{" "}
            {discount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </span>
        </div>
      )}
      {exchangeDiscount > 0 && (
        <div className="flex justify-between items-center px-3 py-2 border-b border-gray-50 bg-white">
          <span className="text-[11px] text-gray-500">Exchange Offset (-)</span>
          <span className="text-[11px] text-green-600 font-semibold">
            LKR{" "}
            {exchangeDiscount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </span>
        </div>
      )}
      <div className="flex justify-between items-center px-3 py-2.5 bg-indigo-50/35 border-t border-indigo-100/30">
        <span className="text-xs font-semibold text-gray-800">Grand Total</span>
        <span className="text-base font-bold text-indigo-600">
          LKR{" "}
          {grandTotal.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}
        </span>
      </div>
    </div>
  );
};
